export interface Staff {
  id :number;
  parent_id :number;
  email :string;
  firstname :string;
  lastname :string;
  mobile :string;
  phone :string;
  photo_url :string;
  handle ?:string;
}

export interface StaffRole {
  role_id :number;
  role :string;
}

export interface Assignee {
  id :number;
  parent_id :number;
  email :string;
  firstname :string;
  lastname :string;
  mobile :string;
  phone :string;
  photo_url :string;
}

export class UserRoleConstants {
  public static SUPER_ADMIN :number = 99;
  public static ADMIN :number = 88;
  public static FACTORY_ADMIN :number = 8;
  public static SALES_MEMBER :number = 2;
  public static STAFF :number = 1;
}
